import React from 'react';
import { FadeIn } from './FadeIn';
export function ExampleQuestionsSection() {
  const questions = ['¿Cuáles son los mayores retos que enfrenta la organización en el corto y mediano plazo?', '¿Qué metas deben alcanzarse en los próximos seis meses?', '¿Cómo describirías la cultura corporativa aquí?', '¿Cuáles son las capacidades clave para tener éxito en este puesto?', '¿Podrías describirme tu estilo de liderazgo?', '¿Esta es una nueva posición o alguien ocupó este rol antes?'];
  return <section className="py-20 lg:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-34">
      <FadeIn data-id="element-35">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-6 tracking-tight" data-id="element-37">
            Preguntas que pueden cambiar por completo una entrevista
          </h2>
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-38">
        {questions.map((question, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-39">
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm h-full relative" data-id="element-40">
              <span className="text-6xl font-serif text-emerald/20 absolute top-4 left-4 leading-none" data-id="element-41">
                "
              </span>
              <p className="text-navy font-medium text-lg relative z-10 pt-4" data-id="element-42">
                {question}
              </p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-43">
        <div className="text-center" data-id="element-44">
          <p className="inline-block bg-lightGray px-6 py-3 rounded-full text-navy font-medium border border-gray-200" data-id="element-45">
            Estas preguntas no solo muestran interés. También te dan información
            para venderte mejor.
          </p>
        </div>
      </FadeIn>
    </section>;
}